/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import './table.scss';
import {formatTableValue, roundToPrecision} from '../../../../../../tokens/js/utils/functions';

export default class ComparisonTable extends React.Component {
  constructor(props) {
    super(props);
    this.getTableBody = this.getTableBody.bind(this);
  }

  getTableBody = (tableData) => {
    if (tableData?.length < 9) {
      return;
    }

    return (
      <tbody>
        <tr>
          <th className="bold" scope="col" colSpan="4">
            Vergangenheit | Absolutwert | gemessen
          </th>
        </tr>
        <tr>
          <th scope="col" />
          <th colSpan="3" className="numbers">
            Mittelwert
          </th>
        </tr>
        <tr>
          <th scope="col">
            Referenzperiode
            <br />
            (1971 - 2000)
          </th>
          <td colSpan="3" className="numbers">
            {formatTableValue(tableData[0][0].value, 1, 1, false)}
            &nbsp;
            {tableData[8]}
          </td>
        </tr>
        <tr className="separator">
          <td colSpan="4">
            <br />
          </td>
        </tr>
        <tr>
          <th className="bold" scope="col" colSpan="4">
            Zukunft | Änderungen zur Vergangenheit | modelliert
          </th>
        </tr>
        <tr>
          <th scope="col" />
          <th scope="col">
            {tableData[10]}
            <br />
            {tableData[9][0]}
          </th>
          <th scope="col">
            {tableData[10]}
            <br />
            {tableData[9][1]}
          </th>
          <th scope="col">Differenz</th>
        </tr>
        <tr>
          <th scope="col">
            nahe Zukunft
            <br />
            (2021 - 2050)
          </th>
          <td className="numbers">
            {formatTableValue(tableData[1], 1)}
            &nbsp;
            {tableData[7]}
          </td>
          <td className="numbers">
            {formatTableValue(tableData[2], 1)}
            &nbsp;
            {tableData[7]}
          </td>
          <td className="numbers">
            {formatTableValue(roundToPrecision(tableData[1],1) - roundToPrecision(tableData[2],1), 1)}
            &nbsp;
            {tableData[7]}
          </td>
        </tr>
        <tr>
          <th scope="col">
            mittlere Zukunft
            <br />
            (2041 - 2070)
          </th>
          <td className="numbers">
            {formatTableValue(tableData[3], 1)}
            &nbsp;
            {tableData[7]}
          </td>
          <td className="numbers">
            {formatTableValue(tableData[4], 1)}
            &nbsp;
            {tableData[7]}
          </td>
          <td className="numbers">
            {formatTableValue(roundToPrecision(tableData[3],1) - roundToPrecision(tableData[4],1), 1)}
            &nbsp;
            {tableData[7]}
          </td>
        </tr>
        <tr>
          <th scope="col">
            ferne Zukunft
            <br />
            (2071 - 2100)
          </th>
          <td className="numbers">
            {formatTableValue(tableData[5], 1)}
            &nbsp;
            {tableData[7]}
          </td>
          <td className="numbers">
            {formatTableValue(tableData[6], 1)}
            &nbsp;
            {tableData[7]}
          </td>
          <td className="numbers">
            {formatTableValue(roundToPrecision(tableData[5],1) - roundToPrecision(tableData[6],1), 1)}
            &nbsp;
            {tableData[7]}
          </td>
        </tr>
      </tbody>
    );
  };

  render() {
    const { tableData, tableCaption } = this.props;
    if (tableData?.length > 0) {
      return (
        <div>
          <table className="table table-striped table-visualization table-sm">
            <caption>{tableCaption}</caption>
            {this.getTableBody(tableData)}
          </table>
        </div>
      );
    }
    return null;
  }
}
